export const comments_5519468 = {"data":{"data":[],"links":{}}}